import React from "react";
import { FlatButton, Paper } from "material-ui";
import connectToStores from "alt-utils/lib/connectToStores";
import get from "lodash/get";

import EventBucketStore from "../../stores/EventBucketStore";

class ChatWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setupData: null
    };
  }

  static getStores() {
    return [EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    const { film, getEventBucketById } = props;
    const eventBucket = getEventBucketById(film.event_bucket);
    const avatar = get(
      eventBucket,
      "frontend_config.virtual_festival_chat_avatar"
    );

    if (
      !this.state.setupData &&
      props.film &&
      props.user &&
      props.token &&
      eventBucket
    ) {
      const name =
        get(eventBucket, "frontend_config.virtual_festival_chat_name") ||
        props.user.organization;

      this.setState({
        setupData: {
          user: {
            id: props.user.id,
            name,
            image:
              avatar ||
              `https://ui-avatars.com/api/?background=random&name=${name}&bold=true`
          },
          token: props.token,
          channel_id:
            (props.film.virtual_content && props.film.virtual_content.id) ||
            props.film.id,
          channel_data: {
            image: props.film.image,
            name: props.film.name.replace(/[^\u0020-\u007e\u00a0-\u00ff]/g, "")
          }
        }
      });
    }
  }

  render() {
    const chatAdminLink = `${process.env.WATCH_SITE_ROOT}admin/chat?data=${btoa(
      JSON.stringify(this.state.setupData)
    )}`;

    return this.state.setupData ? (
      <div>
        <Paper
          style={{
            borderRadius: "15px"
          }}
        >
          <div style={{ padding: "10px", paddingTop: "20px", display: "flex" }}>
            <h2 style={{ flex: 1 }}>Messages</h2>
            <FlatButton
              style={{ marginLeft: "auto" }}
              label="Open in new tab"
              href={chatAdminLink}
              target="_blank"
              primary
            />
          </div>

          <iframe
            src={chatAdminLink}
            style={{
              width: "100%",
              height: 500,
              border: "none",
              borderRadius: "15px"
            }}
          />
        </Paper>
      </div>
    ) : null;
  }
}

export default connectToStores(ChatWidget);



// WEBPACK FOOTER //
// ./src/app/components/partials/chat-widget.jsx